var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 480 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "United Kingdom"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M480 240c0 132.51-107.39 239.94-239.89 240h-2.59a242 242 0 0 1-34.74-2.87 236 236 0 0 1-27.9-6.06A240.08 240.08 0 0 1 0 240C0 107.47 107.42 0 240 0h.11a239.26 239.26 0 0 1 174.34 75.17A239.8 239.8 0 0 1 480 240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M179.43 168.62v10.8h-34.89l-98-81.49a239 239 0 0 1 19.7-23.48zM433.77 98.37l-97.43 81h-35.77v-10.02l113.58-94.49.3.31A237 237 0 0 1 432.79 97zM179.43 300.56v10.8L66.24 405.55c-1-1-2-2.08-2.94-3.13a239 239 0 0 1-16.75-20.35l98-81.51zM433.78 381.62a240 240 0 0 1-19.62 23.51l-113.59-94.5v-10.07h35.77z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#012169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.85 179.42H7.71a237.9 237.9 0 0 1 22-55.07zM93.86 300.56 29 354.5a238 238 0 0 1-21.29-53.94zM179.43 351.28v121c-1.52-.39-3-.8-4.55-1.23a239.1 239.1 0 0 1-86.09-44.68zM179.43 7.71v119.1L90.14 52.53a239.2 239.2 0 0 1 89.29-44.82M391.23 53.65l-90.66 75.15V7.72l1.37.35a239 239 0 0 1 89.29 45.58M472.29 179.42h-86L451 125.58a238.2 238.2 0 0 1 21.29 53.84M392 425.78a239.25 239.25 0 0 1-91.38 46.51V349.76zM472.29 300.56a238.6 238.6 0 0 1-20.65 52.71l-63.35-52.71z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M480 237.49v4.79a242 242 0 0 1-2.63 33.43H275.71v201.65a242.5 242.5 0 0 1-33.22 2.64h-5a241 241 0 0 1-33.23-2.65V275.71H2.64A243 243 0 0 1 0 242.45v-4.73a242 242 0 0 1 2.63-33.44h201.66V2.64A244 244 0 0 1 235.91 0h7.74a240 240 0 0 1 30.19 2.34l1.87.28v201.66h201.65a242 242 0 0 1 2.64 33.21"
  })))));
};
export default SvgUk;